(function () {
  function getCard(el) {
    return el.closest('.t4s-product') ||
           el.closest('.t4s-product-wrapper') ||
           el.closest('.t4s-pr-grid') ||
           el.closest('[data-product-options]') ||
           el.closest('li') ||
           el.closest('article');
  }

  function setCardLinks(card, url) {
    const full = card.querySelector('a.t4s-fullwidth-link');
    if (full) full.href = url;

    const titleLink = card.querySelector('.t4s-product-title a');
    if (titleLink) titleLink.href = url;
  }

  function forceSetImage(img, imgUrl) {
    if (!img || !imgUrl) return;

    img.setAttribute('src', imgUrl);
    img.setAttribute('data-src', imgUrl);

    if (img.hasAttribute('data-lazy-src')) img.setAttribute('data-lazy-src', imgUrl);
    if (img.hasAttribute('data-srcset')) img.setAttribute('data-srcset', imgUrl);
    if (img.hasAttribute('srcset')) img.setAttribute('srcset', '');

    img.classList.remove('lazyloadt4s', 'lazyload', 'lazy');
    img.classList.add('cm-preview-loaded');
  }

  function setCardImage(card, imgUrl) {
    let img = card.querySelector('img[data-cm-card-img]');
    if (!img) img = card.querySelector('img.t4s-product-main-img');
    if (!img) img = card.querySelector('img');
    forceSetImage(img, imgUrl);
  }

  document.addEventListener('click', function (e) {
    const swatch = e.target.closest('.cm-color-swatches--card .cm-swatch');
    if (!swatch) return;

    const card = getCard(swatch);
    if (!card) return;

    const url = swatch.dataset.url || swatch.getAttribute('href');
    const imgUrl = swatch.dataset.img || '';
    const isActive = swatch.classList.contains('is-active');

    // 1° click: preview
    if (!isActive) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      const wrap = swatch.closest('.cm-color-swatches--card');
      if (wrap) wrap.querySelectorAll('.cm-swatch').forEach(a => a.classList.remove('is-active'));
      swatch.classList.add('is-active');

      if (imgUrl) setCardImage(card, imgUrl);
      if (url) setCardLinks(card, url);
      return;
    }

    // 2° click: vai
    e.preventDefault();
    window.location.href = url;
  }, true);
})();
